import { z } from 'zod'
import { oc } from '@orpc/contract'

/**
 * Where the portrait sits on an identity document, as fractions of the image
 * (0–1). Coordinates rather than a cropped image: the browser already holds
 * the full-resolution file, so it can crop better pixels than a re-encoded
 * round trip, and the response stays four numbers.
 */
export const idPhotoRegionSchema = z.object({
  found: z.boolean(),
  box: z
    .object({
      x: z.number().min(0).max(1),
      y: z.number().min(0).max(1),
      width: z.number().min(0).max(1),
      height: z.number().min(0).max(1),
    })
    .optional(),
})
export type IdPhotoRegion = z.infer<typeof idPhotoRegionSchema>

export const patientExtractIdPhoto = oc
  .route({ method: 'POST', path: '/v2/patient/{id}/id-photo-region' })
  .input(
    z.object({
      id: z.string().min(1),
      imageBase64: z.string().min(1),
      mediaType: z.enum(['image/jpeg', 'image/png']),
    }),
  )
  .output(idPhotoRegionSchema)
